import { createReducer } from '@reduxjs/toolkit';
import { initialState } from '@modules/orders-and-trips/store';
import { importOrdersRoutine } from '@modules/orders-and-trips/actions';
import { onFailure } from '@common/utils/helpers/reducers';

export const importOrdersReducer = createReducer(initialState, {
  [importOrdersRoutine.FAILURE]: onFailure
});
